import React from 'react';
import styled from 'styled-components';
import { Box } from 'reflexbox';

import Keyword from '../../../Shared/Keyword';
import KeywordInput from './KeywordInput';

const Keywords = ({ value, onChange, ...props }) => {
  const addKeywords = newKeywords => {
    const updatedKeywords = new Set(value);

    newKeywords.forEach(keyword => {
      updatedKeywords.add(keyword)
    });

    onChange(Array.from(updatedKeywords));
  };

  const removeKeyword = (keywordToRemove) => {
    const newKeywords = value.filter((keyword) => keyword !== keywordToRemove);
    onChange(newKeywords);
  };

  return (
    <Box>
      <Container>
        <KeywordInput onSubmit={addKeywords} placeholder="Type here..." {...props} />
        <TagsContainer>
          {value?.map(el => (
            <Keyword keyword={el} onRemove={removeKeyword} key={el} />
          ))}
        </TagsContainer>
      </Container>
    </Box>
  );
};

const TagsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;
  
`;

export default Keywords;
